var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21914 10.0205C4.46775 11.4216 2.32328 13.5549 0.881959 16.4377L3.11804 17.5557C4.34338 15.1049 6.19891 13.2382 7.78086 11.9727C8.5674 11.3435 9.27412 10.8726 9.7801 10.5612C10.0327 10.4058 10.2343 10.2907 10.3694 10.2161C10.437 10.1789 10.4879 10.1518 10.5201 10.1349L10.5543 10.1171L10.559 10.1147L10.5596 10.1144C10.5596 10.1144 10.5595 10.1144 10.559 10.1134L10.559 7.87991C10.5596 7.8789 10.5596 7.87892 10.5596 7.87893L10.559 7.87863L10.5543 7.87621L10.5201 7.85848C10.4879 7.84156 10.437 7.81446 10.3695 7.7772C10.2343 7.70263 10.0328 7.58756 9.78012 7.43209C9.27414 7.12072 8.56742 6.64981 7.78088 6.02057C6.19892 4.75498 4.34339 2.88827 3.11804 0.4375L0.881958 1.55551C2.32328 4.43823 4.46775 6.5716 6.21912 7.97273C6.71514 8.36954 7.18357 8.71078 7.60131 8.99664C7.18358 9.28249 6.71515 9.62371 6.21914 10.0205Z",
    fill: "#c2c5d5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.72f13953f173e25a3c81e250158511b9.svg";
export { ForwardRef as ReactComponent };